import { SvgIcon } from "@material-ui/core";
import React from "react";

const PotencyIcon = props => (
  <SvgIcon>
    <g id="Icon/PotencyIcon">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="21"
        height="24"
        fill="none"
        viewBox={props.viewBox}
      >
        <g
          stroke={props.color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeMiterlimit="10"
          strokeWidth="2"
          clipPath="url(#PotencyIcon)"
        >
          <path d="M18.15 12.113c-.87 2.347-2.4 3.614-2.4 3.614l1.5 7.523H9l-.75-1.5-3.383-.555a1.512 1.512 0 01-1.252-1.297L3 15l-2.25-.75 1.5-4.357M2.25 9.893l.007-1.238C2.257 4.23 6.045.75 11.206.75M16.875 9c-1.162 0-1.14-.825-1.14-.825v-1.68s.023-.48-.165-.668c-.758-.562-1.328-1.342-1.328-2.34 0-1.507 1.178-2.73 2.633-2.73s2.633 1.223 2.633 2.73c0 .99-.585 1.77-1.343 2.34-.172.113-.165.615-.165.615V8.16c0-.008.038.832-1.125.84zM16.155 7.5h1.372"/>
        </g>
        <defs>
          <clipPath id="PotencyIcon">
            <path fill="#fff" d="M0 0H20.258V24H0z"></path>
          </clipPath>
        </defs>
      </svg>
    </g>
  </SvgIcon>
);

export default PotencyIcon;



// WEBPACK FOOTER //
// ./src/icons/PotencyIcon.jsx